import { z } from 'zod/v3'

import { m } from '@/lib/paraglide/messages'

/** Giới hạn khớp server (usecase/shop/media.go). */
export const MEDIA_ALT_MAX = 300
export const MEDIA_TITLE_MAX = 200

export const createShopMediaSchema = () =>
    z.object({
        alt: z
            .string()
            .max(MEDIA_ALT_MAX, m.media_alt_too_long({ max: MEDIA_ALT_MAX })),
        title: z
            .string()
            .max(
                MEDIA_TITLE_MAX,
                m.media_title_too_long({ max: MEDIA_TITLE_MAX }),
            ),
    })

export type ShopMediaForm = z.infer<ReturnType<typeof createShopMediaSchema>>
